import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/project`;

export const getAllProjectsService = async (getToken, userId) => {
  const token = await getToken();

  try {
    const response = await axios.get(
      `${API_BASE_URL}/get_all_projects/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error getting all projects:", error);
    throw error;
  }
};

export const getProjectQuestionsService = async (getToken, { details }) => {
  const token = await getToken();

  try {
    const response = await axios
      .post(
        `${API_BASE_URL}/get_project_questions`,
        {
          details: `Project Title: ${details.projectTitle} | Project Description: ${details.projectDescription} | Project Due Date: ${details.projectDueDate}`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        return JSON.parse(data.completion);
      });
    return response;
  } catch (error) {
    console.error("Error getting project questions:", error);
    throw error;
  }
};

export const addNewProjectService = async (getToken, projectDetails) => {
  const token = await getToken();

  try {
    const response = await axios.post(
      `${API_BASE_URL}/add_project_with_questions`,
      {
        userId: projectDetails.userId,
        projectId: projectDetails.projectId,
        title: projectDetails.title,
        description: projectDetails.description,
        dueDate: projectDetails.dueDate,
        step: projectDetails.step,
        projectQuestions: projectDetails.projectQuestions,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error adding new project:", error);
    throw error;
  }
};

export const updateProjectService = async (getToken, projectId, project) => {
  const token = await getToken();

  try {
    const response = await axios.post(
      `${API_BASE_URL}/update_project`,
      {
        projectId,
        project,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error updating project:", error);
    throw error;
  }
};

export const addProjectAnswersService = async (
  getToken,
  projectId,
  userAnswers
) => {
  const token = await getToken();

  try {
    const response = await axios.post(
      `${API_BASE_URL}/add_project_answers`,
      {
        projectId,
        ...userAnswers,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error adding project answers:", error);
    throw error;
  }
};

export const getNewProjectTasksService = async (
  getToken,
  {
    projectTitle,
    projectDescription,
    projectDueDate,
    projectQuestionsAndAnswers,
  }
) => {
  const token = await getToken();

  try {
    const response = await axios
      .post(
        `${API_BASE_URL}/get_new_project_tasks`,
        {
          instructions: `
        Project Title: ${projectTitle}
        Project Description: ${projectDescription}
        Project Due Date: ${projectDueDate}
        
        Questions and Answers:
        ${projectQuestionsAndAnswers}
      `.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        return JSON.parse(data.completion);
      });
    return response;
  } catch (error) {
    console.error("Error getting project tasks:", error);
    throw error;
  }
};

export const getProjectThreadService = async (
  getToken,
  { userId, assistantId, chatId, fileId, vectorStoreId, projectId, step }
) => {
  const token = await getToken();

  try {
    const params = new URLSearchParams({
      userId,
      assistantId,
      chatId,
      fileId,
      vectorStoreId,
      projectId,
      step,
    });

    const response = await fetch(
      `${API_BASE_URL}/get_project_thread?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Add token here
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting project thread:", error);
    throw error;
  }
};

export const deleteProjectService = async (getToken, projectId) => {
  const token = await getToken();

  try {
    const response = await axios.delete(
      `${API_BASE_URL}/delete_project/${projectId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};
